import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/logo-black.svg'


const _hoisted_1 = _imports_0 + ' 2x'
const _hoisted_2 = { class: "success-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"check-circle\" data-v-1d10fee6><svg viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d10fee6><path d=\"M6 12l4 4 8-8\" stroke=\"#008000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1d10fee6></path></svg></div><h2 class=\"success-title\" data-v-1d10fee6>Form submitted!</h2><p class=\"success-text\" data-v-1d10fee6>Check your inbox. Exciting things are coming!</p>", 3)),
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
      }, "Back to website")
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "powered-container" }, [
      _createElementVNode("p", null, "Powered by"),
      _createElementVNode("img", {
        src: _imports_0,
        srcset: _hoisted_1,
        alt: "Logo"
      })
    ], -1))
  ], 64))
}